import { render, staticRenderFns } from "./SoQuitButton.vue?vue&type=template&id=d54c3a98&scoped=true&"
import script from "./SoQuitButton.vue?vue&type=script&lang=js&"
export * from "./SoQuitButton.vue?vue&type=script&lang=js&"
import style0 from "./SoQuitButton.vue?vue&type=style&index=0&id=d54c3a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54c3a98",
  null
  
)

export default component.exports